module.exports = __webpack_public_path__ + "img/stone-path-transitions.7391a8ab.png";